import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=4d5f662f&scoped=true"
import script from "./deal.vue?vue&type=script&lang=js"
export * from "./deal.vue?vue&type=script&lang=js"
import style0 from "./deal.vue?vue&type=style&index=0&id=4d5f662f&prod&lang=scss&scoped=true"
import style1 from "./deal.vue?vue&type=style&index=1&id=4d5f662f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5f662f",
  null
  
)

export default component.exports